(function($, root, undefined) {

    var setupMobileNav = function() {
        var $mobileNav = $( '.mobile-nav' );
        var $naviconWrapper = $( '.navicon-wrapper' );

        $naviconWrapper.on( 'click', toggleMobileNav );

        function toggleMobileNav(e) {
            $( this ).find( '.navicon' ).toggleClass( 'opened' );

            var mobileNav = $( '.mobile-nav' );

            if( $( this ).find( '.navicon' ).hasClass( 'opened' ) ) {

                mobileNav.addClass( 'open' );
                var overlay = $( '<div class="overlay"></div>' );
                $( '.tray-wrap' ).prepend( overlay );
                overlay.addClass( 'darken' );
                overlay.on( 'click', function() {
                    $( '.navicon-wrapper' ).trigger( 'click' );
                } );

                $( '.body' ).height( $( window ).height() );

            } else {
                mobileNav.removeClass( 'open' );
                $( '.overlay' ).removeClass( 'darken' );

                $( '.overlay' ).on( 'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function() {
                    $( this ).remove();
                } );
                $( '.body' ).removeAttr( 'style' );
            }
        }
    };

    var setupMobileSubNav = function() {
        var mobileNavSelector = $( '.mobile-nav' ).find( '.m-nav' ),
            speed = 200;

        mobileNavSelector.find( 'a' ).click( function(e) {
            var clicked = $( this ).parent(),
                topList = mobileNavSelector.find( 'li' ),
                body = $( 'html, body' ),
                ulSub = clicked.children( 'ul.sub-menu' );

            //remove all active from as in nav
            mobileNavSelector.find( 'a' ).removeClass( 'active' );
            clicked.children( 'a' ).addClass( 'active' );
            clicked.addClass( 'active' );

            //remove opened class from all siblings
            clicked.siblings().removeClass( 'opened' ).find( '.opened' ).removeClass( 'opened' );
            clicked.siblings().removeClass( 'active' ).find( '.active' ).removeClass( 'active' );


            if( ulSub.length !== 0 && !clicked.hasClass( 'opened' ) ) {
                e.preventDefault();
                clicked.addClass( 'opened' );
                ulSub.slideDown( speed, function() {
                    body.animate( {
                        scrollTop: clicked.offset().top
                    }, speed );
                    /*
                     */
                } );
                //slide up all lis that don't have opened class
                mobileNavSelector.children( 'li' ).each( function() {
                    if( !$( this ).hasClass( 'opened' ) ) {
                        $( this ).find( 'ul.sub' ).slideUp( speed );
                        $( this ).removeClass( 'opened' );
                    }
                } );
                mobileNavSelector.children( 'li.opened' ).addClass( 'active' );
            }
        } );
    };


    $( function() {

        'use strict';

        setupMobileNav();
        setupMobileSubNav();

        $( '.back-to-top' ).find( 'a' ).on( 'click', function(e) {
            e.preventDefault();
            $( "html, body" ).animate( {scrollTop: 0}, 500 );
        } );

        $( '.container' ).fitVids();

        function enquireCallback() {
            enquire.register( "screen and (max-width:767px)", {

                match: function() {
                    "use strict";
                    //setup cycle2
                    this.desktopHero = $( '.hero' ).clone();

                    this.cycleItem = $( '.hero' ).cycle( {
                        slides: 'div.grid-item',
                        autoHeight: 'container',
                        pauseOnHover: true,
                        pager: '.slideshow-pager',
                        log: false,
                        timeout: 4000,
                        swipe: true
                    } );
                },
                unmatch: function() {
                    "use strict";
                    //destroy cycle2
                    this.cycleItem.cycle( 'destroy' );
                    $('.hero' ).replaceWith(this.desktopHero);
                }

            }, false );

        }


        function supportsSVG() {
            return document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );
        }

        if( !supportsSVG() ) {
            $( 'img' ).each( function() {
                var src = $( this ).attr( 'src' );
                if( src.indexOf( '.svg' ) !== -1 ) {
                    var newSrc = src.replace( '.svg', '.png' );
                    $( this ).attr( 'src', newSrc );
                }
            } );
        }

        $( 'input, textarea' ).placeholder();


        //load enhancement
        if( window.matchMedia ) {
            $.getScript( '/wp-content/themes/baptisthealthblog/bower_components/enquire/dist/enquire.min.js', enquireCallback );
        }

    } );

})( jQuery, this );


